'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api-core';
import '../../../config/ApiEndpoint.js';
import '../../constants/values.js';
import '@dynamic-labs/multi-wallet';
import '../../../shared/logger.js';
import '../../constants/colors.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../shared/consts/index.js';
import '../../../store/state/nonce/nonce.js';
import '../../../store/state/projectSettings/projectSettings.js';
import { getEnvironmentId } from '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import { setPrimaryWalletId } from '../../../store/state/primaryWalletId/primaryWalletId.js';
import { getUser } from '../../../store/state/user/user.js';
import '../../../locale/locale.js';
import { storeSelectedWallet } from '../../../data/api/wallets/wallets.js';

const updatePrimaryWalletId = (walletId) => __awaiter(void 0, void 0, void 0, function* () {
    setPrimaryWalletId(walletId);
    const user = getUser();
    if (user) {
        const environmentId = getEnvironmentId();
        yield storeSelectedWallet({ environmentId, walletId });
    }
});

export { updatePrimaryWalletId };
